const isMainNavEnabled = false;

export default [
  {
    path: "overview",
    name: "Overview",
    redirect: "helloworld",
  },
  {
    path: "segment",
    name: "Segment",
    component: () =>
      import(/* webpackChunkName: "marginOpt-home" */ "../views/Segment.vue"),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: "materialgroup",
    name: "Material Group",
    component: () =>
      import(/* webpackChunkName: "marginOpt-home" */ "../views/MaterialGroup.vue"),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: "materialnumber",
    name: "Material Number",
    component: () =>
      import(/* webpackChunkName: "marginOpt-home" */ "../views/MaterialNumber.vue"),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },

  // {
  //   path: "testpage",
  //   name: "Test Page",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "custom-left-nav-testnav" */ "../views/TestNav.vue"
  //     ),
  //   meta: {
  //     mainNavEnabled: isMainNavEnabled,
  //   },
  // },
  // {
  //   path: "apphelp",
  //   name: "App Help",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "custom-left-nav-help" */ "../views/Help.vue"
  //     ),
  //   meta: {
  //     mainNavEnabled: isMainNavEnabled,
  //   },
  // },
  // {
  //   path: "config",
  //   name: "Config",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "custom-left-nav-config" */ "../views/Config.vue"
  //     ),
  //   meta: {
  //     mainNavEnabled: isMainNavEnabled,
  //   },
  // },
  // {
  //   path: "help",
  //   name: "Help",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "custom-left-nav-global-help" */ "@/_views/Help.vue"
  //     ),
  //   meta: {
  //     mainNavEnabled: isMainNavEnabled,
  //   },
  // },
  // {
  //   path: "projects",
  //   name: "Projects",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "custom-left-nav-global-help" */ "../views/ProjectList.vue"
  //     ),
  //   meta: {
  //     mainNavEnabled: isMainNavEnabled,
  //   },
  // },

  //   {
  //     path: "addProject",
  //     name: "Create Project",
  //     component: () =>
  //       import(
  //         /* webpackChunkName: "custom-left-nav-global-help" */ "../views/CreateProject.vue"
  //       ),
  //     meta: {
  //       mainNavEnabled: isMainNavEnabled,
  //     },
  //   },
  //   {
  //     path: "project/:id",
  //     name: "Update Project",
  //     component: () =>
  //       import(
  //         /* webpackChunkName: "custom-left-nav-global-help" */ "../views/UpdateProject.vue"
  //       ),
  //     meta: {
  //       mainNavEnabled: isMainNavEnabled,
  //     },
  //   },
];
